module.exports = __webpack_public_path__ + "exo-latin-600.ed2ff71bda38119fa682.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-600.woff
// module id = ../../../../typeface-exo/files/exo-latin-600.woff
// module chunks = styles